import React, { useState } from 'react';
import { aiAssistantData } from '../utils/mockData';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
const Content: React.FC = () => {
  const [activeTab, setActiveTab] = useState('personas');
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
  return <div className="space-y-6" data-id="element-945">
      <div data-id="element-946">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-947">
          Content & AI Management
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-948">
          Manage AI personas, content, and educational resources.
        </p>
      </div>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-949">
        <div className="border-b border-gray-200 dark:border-gray-700" data-id="element-950">
          <nav className="flex -mb-px" data-id="element-951">
            <button onClick={() => setActiveTab('personas')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'personas' ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'}`} data-id="element-952">
              AI Personas
            </button>
            <button onClick={() => setActiveTab('content')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'content' ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'}`} data-id="element-953">
              Educational Content
            </button>
            <button onClick={() => setActiveTab('insights')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'insights' ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'}`} data-id="element-954">
              AI Insights
            </button>
            <button onClick={() => setActiveTab('prompts')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'prompts' ? 'border-blue-500 text-blue-600 dark:text-blue-400' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'}`} data-id="element-955">
              Prompt Management
            </button>
          </nav>
        </div>
        <div className="p-6" data-id="element-956">
          {activeTab === 'personas' && <div className="space-y-6" data-id="element-957">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-958">
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-959">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-960">
                    AI Persona Usage
                  </h3>
                  <div className="h-[300px]" data-id="element-961">
                    <ResponsiveContainer width="100%" height="100%" data-id="element-962">
                      <PieChart data-id="element-963">
                        <Pie data={aiAssistantData} cx="50%" cy="50%" labelLine={false} outerRadius={100} fill="#8884d8" dataKey="usage" label={({
                      name,
                      percent
                    }) => `${name}: ${(percent * 100).toFixed(0)}%`} data-id="element-964">
                          {aiAssistantData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-965" />)}
                        </Pie>
                        <Tooltip data-id="element-966" />
                        <Legend data-id="element-967" />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6" data-id="element-968">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-969">
                    Persona Performance
                  </h3>
                  <div className="space-y-4" data-id="element-970">
                    <div data-id="element-971">
                      <div className="flex justify-between items-center mb-2" data-id="element-972">
                        <div data-id="element-973">
                          <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-974">
                            Financial Advisor
                          </span>
                          <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-975">
                            Professional guidance on investments and planning
                          </p>
                        </div>
                        <div className="flex items-center" data-id="element-976">
                          <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-977">
                            4.8/5
                          </span>
                          <div className="flex items-center" data-id="element-978">
                            {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-979">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-980" />
                              </svg>)}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-981">
                      <div className="flex justify-between items-center mb-2" data-id="element-982">
                        <div data-id="element-983">
                          <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-984">
                            Budget Coach
                          </span>
                          <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-985">
                            Friendly guidance on budgeting and saving
                          </p>
                        </div>
                        <div className="flex items-center" data-id="element-986">
                          <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-987">
                            4.6/5
                          </span>
                          <div className="flex items-center" data-id="element-988">
                            {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-989">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-990" />
                              </svg>)}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-991">
                      <div className="flex justify-between items-center mb-2" data-id="element-992">
                        <div data-id="element-993">
                          <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-994">
                            Investment Guide
                          </span>
                          <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-995">
                            Expert advice on investment strategies
                          </p>
                        </div>
                        <div className="flex items-center" data-id="element-996">
                          <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-997">
                            4.7/5
                          </span>
                          <div className="flex items-center" data-id="element-998">
                            {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-999">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1000" />
                              </svg>)}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-1001">
                      <div className="flex justify-between items-center mb-2" data-id="element-1002">
                        <div data-id="element-1003">
                          <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1004">
                            Debt Reducer
                          </span>
                          <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1005">
                            Specialized in debt management strategies
                          </p>
                        </div>
                        <div className="flex items-center" data-id="element-1006">
                          <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-1007">
                            4.5/5
                          </span>
                          <div className="flex items-center" data-id="element-1008">
                            {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-1009">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1010" />
                              </svg>)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-1011">
                <div className="p-6 border-b border-gray-200 dark:border-gray-700" data-id="element-1012">
                  <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-1013">
                    AI Personas
                  </h3>
                </div>
                <div className="overflow-x-auto" data-id="element-1014">
                  <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1015">
                    <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-1016">
                      <tr data-id="element-1017">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1018">
                          Persona
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1019">
                          Description
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1020">
                          Usage
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1021">
                          Rating
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1022">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1023">
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1024">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1025">
                          <div className="flex items-center" data-id="element-1026">
                            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-1027">
                              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1028">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-1029" />
                              </svg>
                            </div>
                            <div className="ml-4" data-id="element-1030">
                              <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1031">
                                Financial Advisor
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4" data-id="element-1032">
                          <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1033">
                            Professional guidance on investments and planning
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1034">
                          40%
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1035">
                          <div className="flex items-center" data-id="element-1036">
                            <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-1037">
                              4.8
                            </span>
                            <div className="flex items-center" data-id="element-1038">
                              {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-1039">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1040" />
                                </svg>)}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1041">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1042">
                            Edit
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1043">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1044">
                          <div className="flex items-center" data-id="element-1045">
                            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-1046">
                              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1047">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" data-id="element-1048" />
                              </svg>
                            </div>
                            <div className="ml-4" data-id="element-1049">
                              <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1050">
                                Budget Coach
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4" data-id="element-1051">
                          <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1052">
                            Friendly guidance on budgeting and saving
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1053">
                          25%
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1054">
                          <div className="flex items-center" data-id="element-1055">
                            <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-1056">
                              4.6
                            </span>
                            <div className="flex items-center" data-id="element-1057">
                              {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-1058">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1059" />
                                </svg>)}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1060">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1061">
                            Edit
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1062">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1063">
                          <div className="flex items-center" data-id="element-1064">
                            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-600" data-id="element-1065">
                              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1066">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" data-id="element-1067" />
                              </svg>
                            </div>
                            <div className="ml-4" data-id="element-1068">
                              <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1069">
                                Investment Guide
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4" data-id="element-1070">
                          <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1071">
                            Expert advice on investment strategies
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1072">
                          15%
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1073">
                          <div className="flex items-center" data-id="element-1074">
                            <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-1075">
                              4.7
                            </span>
                            <div className="flex items-center" data-id="element-1076">
                              {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-1077">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1078" />
                                </svg>)}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1079">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1080">
                            Edit
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1081">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1082">
                          <div className="flex items-center" data-id="element-1083">
                            <div className="flex-shrink-0 h-10 w-10 rounded-full bg-red-100 flex items-center justify-center text-red-600" data-id="element-1084">
                              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1085">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-1086" />
                              </svg>
                            </div>
                            <div className="ml-4" data-id="element-1087">
                              <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1088">
                                Debt Reducer
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4" data-id="element-1089">
                          <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1090">
                            Specialized in debt management strategies
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1091">
                          20%
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1092">
                          <div className="flex items-center" data-id="element-1093">
                            <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-1094">
                              4.5
                            </span>
                            <div className="flex items-center" data-id="element-1095">
                              {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-1096">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1097" />
                                </svg>)}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1098">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1099">
                            Edit
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
          {activeTab === 'content' && <div className="space-y-6" data-id="element-1100">
              <div className="flex justify-end" data-id="element-1101">
                <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-1102">
                  Add New Content
                </button>
              </div>
              <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-1103">
                <div className="overflow-x-auto" data-id="element-1104">
                  <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1105">
                    <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-1106">
                      <tr data-id="element-1107">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1108">
                          Title
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1109">
                          Category
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1110">
                          Published Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1111">
                          Status
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1112">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1113">
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1114">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1115">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1116">
                            Understanding Investment Basics
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1117">
                          Investing
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1118">
                          2023-05-15
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1119">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1120">
                            Published
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1121">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1122">
                            Edit
                          </button>
                          <button className="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300" data-id="element-1123">
                            Delete
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1124">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1125">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1126">
                            Budgeting 101
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1127">
                          Budgeting
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1128">
                          2023-04-22
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1129">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1130">
                            Published
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1131">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1132">
                            Edit
                          </button>
                          <button className="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300" data-id="element-1133">
                            Delete
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1134">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1135">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1136">
                            Debt Management Strategies
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1137">
                          Debt
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1138">
                          2023-06-05
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1139">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200" data-id="element-1140">
                            Draft
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1141">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1142">
                            Edit
                          </button>
                          <button className="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300" data-id="element-1143">
                            Delete
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1144">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1145">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1146">
                            Retirement Planning Guide
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1147">
                          Retirement
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1148">
                          2023-05-30
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1149">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1150">
                            Published
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1151">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1152">
                            Edit
                          </button>
                          <button className="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300" data-id="element-1153">
                            Delete
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
          {activeTab === 'insights' && <div className="space-y-6" data-id="element-1154">
              <div className="flex justify-end" data-id="element-1155">
                <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-1156">
                  Generate New Insight
                </button>
              </div>
              <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-1157">
                <div className="overflow-x-auto" data-id="element-1158">
                  <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1159">
                    <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-1160">
                      <tr data-id="element-1161">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1162">
                          Insight
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1163">
                          Category
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1164">
                          Generated Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1165">
                          Status
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1166">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1167">
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1168">
                        <td className="px-6 py-4" data-id="element-1169">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1170">
                            Users who set specific savings goals are 45% more
                            likely to achieve them
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1171">
                          Saving
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1172">
                          2023-06-08
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1173">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1174">
                            Approved
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1175">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1176">
                            Edit
                          </button>
                          <button className="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300" data-id="element-1177">
                            Delete
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1178">
                        <td className="px-6 py-4" data-id="element-1179">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1180">
                            Millennial users are investing 30% more in ETFs
                            compared to older demographics
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1181">
                          Investing
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1182">
                          2023-06-07
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1183">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200" data-id="element-1184">
                            Pending Review
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1185">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1186">
                            Review
                          </button>
                          <button className="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300" data-id="element-1187">
                            Delete
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1188">
                        <td className="px-6 py-4" data-id="element-1189">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1190">
                            Users who connect multiple bank accounts are 3x more
                            likely to upgrade to premium
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1191">
                          Banking
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1192">
                          2023-06-05
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1193">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1194">
                            Approved
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1195">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1196">
                            Edit
                          </button>
                          <button className="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300" data-id="element-1197">
                            Delete
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
          {activeTab === 'prompts' && <div className="space-y-6" data-id="element-1198">
              <div className="flex justify-end" data-id="element-1199">
                <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-1200">
                  Create New Prompt
                </button>
              </div>
              <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-1201">
                <div className="overflow-x-auto" data-id="element-1202">
                  <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1203">
                    <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-1204">
                      <tr data-id="element-1205">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1206">
                          Prompt Name
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1207">
                          Persona
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1208">
                          Response Rate
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1209">
                          User Rating
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1210">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1211">
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1212">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1213">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1214">
                            Investment Recommendation
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1215">
                          Financial Advisor
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1216">
                          98.2%
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1217">
                          <div className="flex items-center" data-id="element-1218">
                            <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-1219">
                              4.8
                            </span>
                            <div className="flex items-center" data-id="element-1220">
                              {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-1221">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1222" />
                                </svg>)}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1223">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1224">
                            Edit
                          </button>
                          <button className="text-purple-600 hover:text-purple-900 dark:text-purple-400 dark:hover:text-purple-300" data-id="element-1225">
                            A/B Test
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1226">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1227">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1228">
                            Budget Analysis
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1229">
                          Budget Coach
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1230">
                          97.5%
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1231">
                          <div className="flex items-center" data-id="element-1232">
                            <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-1233">
                              4.6
                            </span>
                            <div className="flex items-center" data-id="element-1234">
                              {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-1235">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1236" />
                                </svg>)}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1237">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1238">
                            Edit
                          </button>
                          <button className="text-purple-600 hover:text-purple-900 dark:text-purple-400 dark:hover:text-purple-300" data-id="element-1239">
                            A/B Test
                          </button>
                        </td>
                      </tr>
                      <tr className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1240">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1241">
                          <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1242">
                            Debt Payoff Strategy
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1243">
                          Debt Reducer
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1244">
                          96.8%
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1245">
                          <div className="flex items-center" data-id="element-1246">
                            <span className="text-sm font-medium text-gray-900 dark:text-white mr-2" data-id="element-1247">
                              4.5
                            </span>
                            <div className="flex items-center" data-id="element-1248">
                              {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`h-4 w-4 ${star <= 4 ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-600'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-1249">
                                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-1250" />
                                </svg>)}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1251">
                          <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1252">
                            Edit
                          </button>
                          <button className="text-purple-600 hover:text-purple-900 dark:text-purple-400 dark:hover:text-purple-300" data-id="element-1253">
                            A/B Test
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
export default Content;